import axios from "./httpService";

export const sendFeedbackApi = values =>
  axios.post("/v3/support/feedback", values);
